import { Howl } from "howler";
import {
  createMovieClip,
  shuffleArray,
} from "../../../../../common/functions/Functions_General";

import { Button } from "../../../../../common/gameLib/buttonsLibrary";
import { GameData } from "../../../gamestate/gameData";
import { onPlayButtonDown } from "../../../inGameFunction";
import DeviceChecker from "../../../../../common/functions/helper.ts/DeviceChecker";

export class BonusSymbolPickerBookAnimation {
  private parent: PIXI.Container = new PIXI.Container();
  // private shakeBookTween:PIXI.tween.Tween;
  private book: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("BOOK_front_glow.png")
  );

  private pointerHour: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("hoursNeddle.png")
  );
  private pointerMin: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("minuteNeddle.png")
  );
  private spinningOverlayGlow: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("spiningOrbit.png")
  );
  private activeGameData: GameData;
  private spinningOverlayLine_small: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("spinBook.png")
  ); // animation around the  clock

  private spinningBlueToGoldeffect: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgFixed.png")
  );
  private smallWinSparksAnimationIN: PIXI.extras.AnimatedSprite;
  private shockwaveTween: PIXI.tween.Tween;
  // private spinningOverlayLine_big:PIXI.Sprite;
  // private symbolAnimation:Array<PIXI.extras.AnimatedSprite>;
  // private symbolBG:PIXI.extras.AnimatedSprite;
  private bookMaxScale: number = 0.6;
  private animationOneContainer: PIXI.Container = new PIXI.Container();

  private allBonusSymbols: Array<PIXI.Texture> = [];
  private allBaseSymbols: Array<PIXI.Texture> = [];

  private symbol: Array<PIXI.Sprite> = [];

  private symbolAppearingtween: Array<PIXI.tween.Tween> = []; //- symbolin with zoomeffect
  private tweenspinningOverlayLine_small: PIXI.tween.Tween; //- tween for book oberlay spin
  private tweenTwoParentCircleRotateAround: PIXI.tween.Tween; //-all symbol parent start rotating
  private tweenTwoParentCircleRotateAroundCounterRotation: Array<
    PIXI.tween.Tween
  > = []; //symbol rotate in opposite direction of parent to  stay fixed;
  private tweenSymbolsgettingInsideBook: Array<PIXI.tween.Tween> = []; //  symbolGetting Inside Book
  private tweenBookIn: PIXI.tween.Tween; //-all symbol parent start rotating ;
  private tweenBookFloating: PIXI.tween.Tween;

  private tweenBookHit: PIXI.tween.Tween;
  private tweenBookSpinGlow: PIXI.tween.Tween;
  private tweenBookSpinInGlow: PIXI.tween.Tween;
  private tweenBookPulseGlow: PIXI.tween.Tween;

  private tweenBookShake: PIXI.tween.Tween;
  private startThrowCounterAfterXShake: number = 15; ///after the book shake 15 times it will throw
  // private startThrowEndAfterXShake: number = 120; ///after the book shake 15 times it will throw
  private shakeCounters: number = 0;
  private tweenthrowSymbolsAway: Array<PIXI.tween.Tween> = []; //  symbolGetting Inside Book
  private isOpen: boolean = false;
  private opticalFlare: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("lensFlare_Sparks.png")
  );
  private opticalFlareTween: PIXI.tween.Tween;
  private opticalFlareOutTween: PIXI.tween.Tween;
  private opticalExplosion: PIXI.extras.AnimatedSprite = createMovieClip(
    "expandBg",
    0,
    24
  );
  private tweenBonusSymbolIn: PIXI.tween.Tween;
  private bonusSymbolSelectedBG: PIXI.extras.AnimatedSprite = createMovieClip(
    "specialSymbolBG",
    0,
    20
  );

  private revealExplosionStart: PIXI.extras.AnimatedSprite = createMovieClip(
    "expandBg",
    0,
    24
  );
  private allSymbolMovieClips: Array<PIXI.extras.AnimatedSprite> = [];
  private bonusSymbolSelected: PIXI.extras.AnimatedSprite = createMovieClip(
    "specialSymbolBG",
    0,
    20
  );

  private bgPickedSymbol: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("lensFlare_Sparks2.png")
  );
  private bgPickedSymbolTween: PIXI.tween.Tween;
  private resultIndex: number = 0;

  private bgBookStart: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgFixed.png")
  );
  private bgFlareSpinTween: PIXI.tween.Tween;
  private bgFlareshrinkInTween: PIXI.tween.Tween;

  // private tweenBookShake: PIXI.tween.Tween; //-all symbol parent start rotating ;

  private tweenClock: PIXI.tween.Tween;

  private symbolInEffects: Array<PIXI.extras.AnimatedSprite> = [];
  private maskAnimation: PIXI.Graphics;

  private labelBonusGame: PIXI.Text;
  private labelBonusGameTween: PIXI.tween.Tween;
  private buttonExitlabel: PIXI.Text;
  private buttonExit: Button = new Button(
    new PIXI.Sprite(PIXI.Texture.fromFrame("bonusButtom.png")),
    new PIXI.Rectangle(-175, -50, 350, 100)
  ); // fix hitbox

  private skipBtn: Button = new Button(
    new PIXI.Sprite(PIXI.Texture.fromFrame("skipBtnBookOfTime.png")),
    new PIXI.Rectangle(-175, -50, 350, 100)
  ); // fix hitbox
  private buttonExitTest: Button = new Button(
    new PIXI.Sprite(PIXI.Texture.fromFrame("btn_Autoplay.png")),
    new PIXI.Rectangle(-175, -50, 350, 100)
  ); // fix hitbox

  ///all the sounds
  private sound_spinning: Howl;

  private sound_hitBook: Howl;
  private sound_throwSymbol: Howl;
  private sound_revealSymbol: Howl;
  private sound_revealSymbolLonger: Howl;
  private sound_symbolIn: Howl;
  private ended: boolean = false;

  constructor(parent: PIXI.Container, activeGameData: GameData) {
    this.activeGameData = activeGameData;

    //buttons
    this.createButtons();

    //sounds
    this.createSounds();
    //test
    this.parent.alpha = 1;
    //
    parent.addChild(this.parent);

    this.parent.addChild(this.revealExplosionStart);
    this.revealExplosionStart.anchor.set(0.5);
    this.revealExplosionStart.scale.set(2);
    this.revealExplosionStart.blendMode = PIXI.BLEND_MODES.ADD;
    this.revealExplosionStart.gotoAndStop(0);
    this.revealExplosionStart.loop = true;
    this.revealExplosionStart.animationSpeed = 0.33;

    //--line and label
    this.createLinesAndTitel();

    this.parent.addChild(this.bgBookStart);

    this.bgBookStart.anchor.set(0.5);
    this.bgBookStart.blendMode = PIXI.BLEND_MODES.ADD;
    let scale = 1.5;
    this.bgFlareSpinTween = PIXI.tweenManager.createTween(this.bgBookStart);
    this.bgFlareSpinTween
      .from({ alpha: 1, scale: { x: scale, y: scale }, rotation: 0 })
      .to({ alpha: 1, scale: { x: scale, y: scale }, rotation: -Math.PI });
    this.bgFlareSpinTween.time = 2000;
    this.bgFlareSpinTween.loop = true;

    this.bgFlareSpinTween.easing = PIXI.tween.Easing.linear();

    this.bgFlareshrinkInTween = PIXI.tweenManager.createTween(this.bgBookStart);
    this.bgFlareshrinkInTween
      .from({
        alpha: 1,
        scale: { x: scale, y: scale },
        rotation: this.bgBookStart.rotation,
      })
      .to({
        alpha: 0,
        scale: { x: scale, y: scale },
        rotation: this.bgBookStart.rotation - Math.PI,
      });
    this.bgFlareshrinkInTween.time = 1500;
    // this.bgFlareshrinkInTween.delay=1800;
    this.bgFlareshrinkInTween.loop = false;
    this.bgFlareshrinkInTween.easing = PIXI.tween.Easing.linear();
    // this.bgFlareshrinkInTween.start();

    this.parent.addChild(this.animationOneContainer);
    this.book.anchor.set(0.5);
    this.pointerHour.anchor.set(0.5);
    this.pointerMin.anchor.set(0.5);
    this.spinningOverlayGlow.anchor.set(0.5);

    //-create dirt effects behind book
    this.spinningBlueToGoldeffect.anchor.set(0.5);
    this.parent.addChild(this.spinningBlueToGoldeffect);
    this.spinningBlueToGoldeffect.blendMode = PIXI.BLEND_MODES.ADD;

    this.smallWinSparksAnimationIN = createMovieClip(
      "smallWinAnimations",
      0,
      19
    );
    this.smallWinSparksAnimationIN.anchor.set(0.5);
    this.smallWinSparksAnimationIN.loop = false;
    this.smallWinSparksAnimationIN.blendMode = PIXI.BLEND_MODES.ADD;
    this.smallWinSparksAnimationIN.scale.set(1.5);
    this.parent.addChild(this.smallWinSparksAnimationIN);

    ///clock animation
    this.tweenClock = PIXI.tweenManager.createTween(this.pointerHour);
    this.tweenClock.from({ rotation: 0 }).to({ rotation: -Math.PI * 2 });
    ///choosenSymbol
    // movieclip
    //-total of  9 symbols startinh index 0
    for (let i = 0; i < 9; i++) {
      //-create movie clips with alll symbols
      let clipName = this.activeGameData.tileImgNamePast[i];
      let clipLength = this.activeGameData.tileImgEnd[i];
      this.allSymbolMovieClips[i] = createMovieClip(clipName, 0, clipLength);
    }
    //bg

    this.bgPickedSymbol.anchor.set(0.5);
    this.bgPickedSymbol.blendMode = PIXI.BLEND_MODES.ADD;
    this.bgPickedSymbol.alpha = 0;
    this.bgPickedSymbol.scale.set(1.5);
    this.bgPickedSymbolTween = PIXI.tweenManager.createTween(
      this.bgPickedSymbol
    );
    this.bgPickedSymbolTween
      .from({ alpha: 1, rotation: 0 })
      .to({ alpha: 1, rotation: Math.PI });
    this.bgPickedSymbolTween.time = 2000;
    this.bgPickedSymbolTween.loop = true;
    this.bgPickedSymbolTween.easing = PIXI.tween.Easing.linear();

    this.parent.addChild(this.bgPickedSymbol);

    ///-
    this.bonusSymbolSelectedBG = createMovieClip("specialSymbolBG", 0, 20);
    this.bonusSymbolSelectedBG.anchor.set(0.5);
    this.bonusSymbolSelectedBG.animationSpeed = 0.35;
    this.bonusSymbolSelectedBG.scale.set(1.2);
    this.parent.addChild(this.bonusSymbolSelectedBG);
    this.bonusSymbolSelectedBG.alpha = 0;
    this.bonusSymbolSelectedBG.gotoAndStop(0);

    this.bonusSymbolSelected = createMovieClip("specialSymbolBG", 0, 20);
    this.bonusSymbolSelected.anchor.set(0.5);
    this.bonusSymbolSelected.animationSpeed = 0.35;
    // this.bonusSymbolSelectedBG.scale.set(1.2);
    this.bonusSymbolSelectedBG.addChild(this.bonusSymbolSelected);
    this.bonusSymbolSelected.alpha = 0;
    this.bonusSymbolSelected.gotoAndStop(0);

    //-

    //create book
    this.parent.addChild(this.book);

    this.book.addChild(this.pointerHour);
    this.book.alpha = 0;
    this.pointerHour.anchor.set(0.5, 0.421);
    this.pointerHour.y = 0; //-43;
    this.pointerMin.anchor.set(0.5, 0.421);
    this.pointerHour.addChild(this.pointerMin);
    this.parent.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
    this.parent.scale.set(2);
    this.book.addChild(this.spinningOverlayGlow);
    this.book.addChild(this.spinningOverlayLine_small);
    this.spinningOverlayLine_small.anchor.set(0.5);
    this.spinningOverlayLine_small.y = 0; //-40;
    this.spinningOverlayLine_small.blendMode = PIXI.BLEND_MODES.ADD;
    this.spinningOverlayLine_small.alpha = 0;
    this.spinningOverlayLine_small.scale.set(1.5);
    this.spinningOverlayGlow.blendMode = PIXI.BLEND_MODES.ADD;
    this.spinningOverlayGlow.alpha = 0;
    this.spinningOverlayGlow.y = 0; //-40;

    ///-optical falre glow

    this.parent.addChild(this.opticalFlare);
    this.opticalFlare.anchor.set(0.5);
    this.opticalFlare.scale.set(1.5);
    this.opticalFlare.blendMode = PIXI.BLEND_MODES.ADD;
    this.opticalFlare.alpha = 0;

    this.parent.addChild(this.opticalExplosion);
    this.opticalExplosion.anchor.set(0.5);
    this.opticalExplosion.scale.set(3);
    this.opticalExplosion.blendMode = PIXI.BLEND_MODES.ADD;
    this.opticalExplosion.gotoAndStop(0);
    this.opticalExplosion.loop = false;

    ///- create mask
    this.maskAnimation = new PIXI.Graphics()
      .beginFill(0xff0000)
      .drawRect(-activeGameData.size[0] / 2, -260, activeGameData.size[0], 800)
      .endFill();
    this.maskAnimation;
    // this.parent.addChild(this.maskAnimation);
    // this.animationOneContainer.mask=this.maskAnimation;
    this.createAnimations();
    this.close();
  }
  private createSounds = (): void => {
    this.sound_spinning = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/BonusSelect Egyptian Sands Transition 2_01.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 1,
      sprite: {
        sound: [500, 5094, false],
      },
    });

    this.sound_hitBook = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/BonusSelect Magic Hit 1.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.9,
      sprite: {
        sound: [100, 2899, false],
      },
    });

    this.sound_throwSymbol = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/Bonus Select Whoosh Accent 1.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.5,
      sprite: {
        sound: [80, 1000, false],
      },
    });

    this.sound_revealSymbol = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/BonusSelect Win Whoosh.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 1,
      sprite: {
        sound: [200, 2677, false],
      },
    });
    this.sound_revealSymbolLonger = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/BonusSelect Win Swish 2.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 1,
      sprite: {
        sound: [0, 2900, false],
      },
    });
    this.sound_symbolIn = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/Egyptian Award_01.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.5,
      sprite: {
        sound: [400, 2000, false],
      },
    });
    //--add sounds to the list so that menu can mute/unmute them
    this.activeGameData.soundList.push(this.sound_spinning);
    this.activeGameData.soundList.push(this.sound_hitBook);
    this.activeGameData.soundList.push(this.sound_throwSymbol);
    this.activeGameData.soundList.push(this.sound_revealSymbol);
    this.activeGameData.soundList.push(this.sound_revealSymbolLonger);
    this.activeGameData.soundList.push(this.sound_symbolIn);
  };
  private stopAllSounds = (): void => {
    this.sound_spinning.stop();
    this.sound_hitBook.stop();
    this.sound_throwSymbol.stop();
    this.sound_revealSymbol.stop();
    this.sound_revealSymbolLonger.stop();
    this.sound_symbolIn.stop();
  };
  private createAnimations = (): void => {
    let totalSymbols = 9;
    let allBaseSymbols = this.activeGameData.tileImgName;
    let allBonusSymbolsName = this.activeGameData.tileImgNamePast;

    for (let i = 0; i < totalSymbols; i++) {
      this.symbolInEffects[i] = createMovieClip("expandBg", 0, 24);

      this.symbolInEffects[i].anchor.set(0.5);
      this.symbolInEffects[i].loop = false;
      this.symbolInEffects[i].scale.set(1.5);
      this.symbolInEffects[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.symbolInEffects[i].gotoAndStop(0);
      this.symbolInEffects[i].animationSpeed = 0.23;
      this.symbolInEffects[i].tint = 0x2222ff;

      this.symbol[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame(allBaseSymbols[i] + "_00000.png")
      );

      this.symbol[i].anchor.set(0.5);
      this.symbol[i].alpha = 0;
      this.animationOneContainer.addChild(this.symbol[i]);
      this.symbol[i].addChild(this.symbolInEffects[i]);

      //-create all bonus symbols

      this.allBonusSymbols[i] = PIXI.Texture.fromFrame(
        allBonusSymbolsName[i] + "_00000.png"
      );

      //create all baseSymbols;
      this.allBaseSymbols[i] = PIXI.Texture.fromFrame(
        allBaseSymbols[i] + "_00000.png"
      );
    }

    this.createTween1();
    this.createTween2();
  };
  private createLinesAndTitel = (): void => {
    let textStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 20,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#f9d349", "#fefc9d"],
      fontWeight: "bold",
      fontSize: 35,
      align: "left",
      wordWrap: true,
      wordWrapWidth: 800,
    });

    this.labelBonusGame = new PIXI.Text(
      this.activeGameData.gameText.specialExpandingSymbol,
      textStyle
    );

    this.labelBonusGame.anchor.set(0.5);
    this.labelBonusGame.y = -this.labelBonusGame.height - 250; //activeGameData.size[0]/2+ this.labelBonusGame.height;

    this.labelBonusGame.alpha = 0;
    this.parent.addChild(this.labelBonusGame);

    this.labelBonusGameTween = PIXI.tweenManager.createTween(
      this.labelBonusGame
    );
    this.labelBonusGameTween
      .from({ alpha: 0, y: -this.activeGameData.size[1] / 2 + 250 })
      .to({ alpha: 1, y: -this.activeGameData.size[1] / 2 + 150 });
    this.labelBonusGameTween.time = 1000;
    // this.tweenBookShake.delay = 1000;
    this.labelBonusGameTween.loop = false;
    this.labelBonusGameTween.easing = PIXI.tween.Easing.outBack();
    let lineScaleX = 0.65;
    let lineScaleY = 1;
    let line: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.fromFrame("wl_0.png"));
    this.labelBonusGame.addChild(line);
    line.anchor.set(0.45, 0.16966);
    line.scale.set(lineScaleX, lineScaleY);
    let line2: PIXI.Sprite = new PIXI.Sprite(
      PIXI.Texture.fromFrame("wl_0.png")
    );
    this.labelBonusGame.addChild(line2);
    line2.anchor.set(0.45, 0.16966);
    line2.scale.set(-lineScaleX, lineScaleY);
    line.y = 30;
    line2.y = 30;
  };
  private createTween1 = (): void => {
    let radius = 300;
    let angleBetweenSymbols = (Math.PI * 2) / this.symbol.length;
    for (let i = 0; i < this.symbol.length; i++) {
      let angle = angleBetweenSymbols * i;
      let posx = radius * Math.cos(angle);
      let posy = radius * Math.sin(angle);

      this.symbolAppearingtween[i] = PIXI.tweenManager.createTween(
        this.symbol[i]
      );
      this.symbolAppearingtween[i]
        .from({ scale: { x: 0, y: 0 }, alpha: 0, x: posx, y: posy })
        .to({ scale: { x: 0.6, y: 0.6 }, alpha: 1, x: posx, y: posy });
      this.symbolAppearingtween[i].time = 800;
      this.symbolAppearingtween[i].loop = false;
      this.symbolAppearingtween[i].easing = PIXI.tween.Easing.outBack();

      this.symbolAppearingtween[i].delay = i * 250;
      this.symbolAppearingtween[i].on(
        "start",
        function(self: BonusSymbolPickerBookAnimation, i: number) {
          if (self.symbolInEffects[i] != undefined) {
            //audio
            self.sound_symbolIn.stop();
            self.sound_symbolIn.play("sound");
            //-anim

            self.symbolInEffects[i].gotoAndPlay(0);
          }
        }.bind(this.symbolAppearingtween[i], this, i)
      );
      // this.symbolAppearingtween[i].start();
    }
  };
  private createTween2 = (): void => {
    this.tweenTwoParentCircleRotateAround = PIXI.tweenManager.createTween(
      this.animationOneContainer
    );
    this.tweenTwoParentCircleRotateAround.to({
      rotation: this.animationOneContainer.rotation - Math.PI * 2,
    });
    this.tweenTwoParentCircleRotateAround.time = 2000;
    this.tweenTwoParentCircleRotateAround.loop = true;
    // this.tweenTwoParentCircleRotateAround.repeat = 5;
    this.tweenTwoParentCircleRotateAround.easing = PIXI.tween.Easing.linear();
    //--start at the end of the last tween form the symbolAppearingtween;
    // this.symbolAppearingtween[this.symbolAppearingtween.length-1].on(
    //   "start",
    //   this.startAnimationTween2
    // );

    // this.symbolAppearingtween[0].on("end",this.startAnimationTween2);

    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.tweenTwoParentCircleRotateAroundCounterRotation[
        i
      ] = PIXI.tweenManager.createTween(this.symbol[i]);
      this.tweenTwoParentCircleRotateAroundCounterRotation[i]
        .from({ rotation: 0 })
        .to({ rotation: +Math.PI * 2 });
      this.tweenTwoParentCircleRotateAroundCounterRotation[
        i
      ].time = this.tweenTwoParentCircleRotateAround.time;
      this.tweenTwoParentCircleRotateAroundCounterRotation[
        i
      ].loop = this.tweenTwoParentCircleRotateAround.loop;
      this.tweenTwoParentCircleRotateAroundCounterRotation[
        i
      ].repeat = this.tweenTwoParentCircleRotateAround.repeat;
      this.tweenTwoParentCircleRotateAroundCounterRotation[
        i
      ].easing = PIXI.tween.Easing.linear();
    }

    this.createTweenSymbolsGettingInsideBook();
  };
  private startAnimationTween2 = (): void => {
    this.animationOneContainer.rotation = 0;

    this.tweenTwoParentCircleRotateAround.reset();
    this.tweenTwoParentCircleRotateAround.start();
    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.tweenTwoParentCircleRotateAroundCounterRotation[i].reset();
      this.tweenTwoParentCircleRotateAroundCounterRotation[i].start();
      // console.log("CCC")
    }
  };

  private scaleDownSpinningBlueEffect = (): void => {
    this.bgFlareSpinTween.stop();
    this.bgFlareshrinkInTween.reset();
    this.bgFlareshrinkInTween.start();
  };

  public createTweenSymbolsGettingInsideBook = (): void => {
    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.tweenSymbolsgettingInsideBook[i] = PIXI.tweenManager.createTween(
        this.symbol[i]
      );
      this.tweenSymbolsgettingInsideBook[i].to({ x: 0, y: 0 });
      this.tweenSymbolsgettingInsideBook[i].time = 800; //this.tweenTwoParentCircleRotateAround.time
      this.tweenSymbolsgettingInsideBook[i].loop = false;
      this.tweenSymbolsgettingInsideBook[i].delay =
        1800 +
        i * (this.tweenTwoParentCircleRotateAround.time / this.symbol.length);
      this.tweenSymbolsgettingInsideBook[i].easing = PIXI.tween.Easing.inBack();
    }

    this.tweenSymbolsgettingInsideBook[
      this.tweenSymbolsgettingInsideBook.length - 2
    ].on("start", this.scaleDownSpinningBlueEffect);

    this.tweenTwoParentCircleRotateAround.on(
      "start",
      this.startTweenGettingInsideBook
    );

    this.createTweenBookIn();

    ///-create tween book throw aways unpicked symbols so 8 symbols are thrwon away
    for (let i = 0; i < this.symbolAppearingtween.length - 1; i++) {
      this.tweenthrowSymbolsAway[i] = PIXI.tweenManager.createTween(
        this.symbol[i]
      );
      this.tweenthrowSymbolsAway[i].time = 1000; //this.tweenTwoParentCircleRotateAround.time
      this.tweenthrowSymbolsAway[i].loop = false;
      // this.tweenthrowSymbolsAway[i].delay = i*300;
      this.tweenthrowSymbolsAway[i].easing = PIXI.tween.Easing.linear();
      this.tweenthrowSymbolsAway[i].on("start", this.playThrowSound);
    }

    this.tweenthrowSymbolsAway[this.tweenthrowSymbolsAway.length - 1].on(
      "end",
      this.endShakeandThrow
    );
  };

  private startTweenGettingInsideBook = (): void => {
    // console.log("start")
    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.tweenSymbolsgettingInsideBook[i].reset();
      this.tweenSymbolsgettingInsideBook[i].start();
    }
  };

  private createTweenBookIn = (): void => {
    this.shockwaveTween = PIXI.tweenManager.createTween(
      this.spinningBlueToGoldeffect
    );
    let scale = 0.8;
    this.shockwaveTween
      .from({ scale: { x: scale, y: scale }, alpha: 1, rotation: 0 })
      .to({ scale: { x: scale, y: scale }, alpha: 1, rotation: -Math.PI * 2 });
    this.shockwaveTween.time = 2000;
    this.shockwaveTween.easing = PIXI.tween.Easing.linear();
    this.shockwaveTween.loop = true;
    // this.shockwaveTween.delay = 400;

    this.shockwaveTween.on(
      "start",
      function(self: BonusSymbolPickerBookAnimation) {
        self.smallWinSparksAnimationIN.gotoAndPlay(0);
      }.bind(this.shockwaveTween, this)
    );

    ///-create book in animation

    this.tweenBookIn = PIXI.tweenManager.createTween(this.book);
    this.tweenBookIn.from({ scale: { x: 2, y: 2 }, y: -200, alpha: 0 }).to({
      scale: { x: this.bookMaxScale, y: this.bookMaxScale },
      alpha: 1,
      y: 0,
    });

    // this.tweenBookIn.loop = true;
    this.tweenBookIn.time = 1000;
    // this.tweenBookIn.pingPong =true;
    // this.tweenBookIn.easing = PIXI.tween.Easing.linear();
    this.tweenBookIn.on("end", this.startAnimationTwo);
    this.tweenBookIn.easing = PIXI.tween.Easing.outBack();

    //--book flaoting aniamtion
    this.tweenBookFloating = PIXI.tweenManager.createTween(this.book);
    this.tweenBookFloating.from({ y: 0 }).to({ y: -20 });
    this.tweenBookFloating.time = 3000;
    this.tweenBookFloating.loop = true;
    this.tweenBookFloating.pingPong = true;
    this.tweenBookFloating.easing = PIXI.tween.Easing.outSine();

    this.tweenBookHit = PIXI.tweenManager.createTween(this.book);
    this.tweenBookHit
      .from({ scale: { x: this.bookMaxScale, y: this.bookMaxScale } })
      .to({
        scale: { x: this.bookMaxScale * 0.8, y: this.bookMaxScale * 0.8 },
      });
    this.tweenBookHit.time = 500;
    this.tweenBookHit.loop = false;
    this.tweenBookHit.pingPong = true;
    this.tweenBookHit.easing = PIXI.tween.Easing.linear();

    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.tweenSymbolsgettingInsideBook[i].on("end", this.bookHitAnimation);
    }

    //create tween spinning effect around book

    // spineffect gettin in
    this.tweenBookSpinInGlow = PIXI.tweenManager.createTween(
      this.spinningOverlayGlow
    );
    this.tweenBookSpinInGlow
      .from({ rotation: 0, alpha: 0, scale: { x: 0.5, y: 0.5 } })
      .to({ rotation: -Math.PI * 2, alpha: 1, scale: { x: 1, y: 1 } });
    this.tweenBookSpinInGlow.time = 1000;
    this.tweenBookSpinInGlow.loop = false;
    this.tweenBookSpinInGlow.easing = PIXI.tween.Easing.outBack();

    //--spin animation
    this.tweenBookSpinGlow = PIXI.tweenManager.createTween(
      this.spinningOverlayGlow
    );
    this.tweenBookSpinGlow
      .from({ rotation: 0, alpha: 1 })
      .to({ rotation: -Math.PI * 2, alpha: 1 });
    this.tweenBookSpinGlow.time = 1000;
    this.tweenBookSpinGlow.loop = true;
    // this.tweenBookSpinGlow.pingPong = true;
    this.tweenBookSpinGlow.easing = PIXI.tween.Easing.linear();

    this.tweenBookSpinInGlow.on("end", this.startLightSpinEffect);

    //create tween to  make book flaoting
    this.tweenBookPulseGlow = PIXI.tweenManager.createTween(
      this.spinningOverlayGlow
    );
    this.tweenBookPulseGlow
      .from({ scale: { x: 1, y: 1 } })
      .to({ scale: { x: 1.2, y: 1.2 } });
    this.tweenBookPulseGlow.time = 1000;
    this.tweenBookPulseGlow.loop = true;
    this.tweenBookPulseGlow.pingPong = true;
    this.tweenBookPulseGlow.easing = PIXI.tween.Easing.linear();

    this.tweenTwoParentCircleRotateAround.on("start", this.spinGlowAroundBook);

    ///-create shake tween
    this.tweenBookShake = PIXI.tweenManager.createTween(this.book);
    this.tweenBookShake.from({ rotation: 0 }).to({ rotation: 0 });
    this.tweenBookShake.time = 30;
    // this.tweenBookShake.delay = 1000;
    this.tweenBookShake.loop = false;
    this.tweenBookShake.easing = PIXI.tween.Easing.linear();
    this.tweenBookShake.on("end", this.shakeNewPosition);

    this.tweenSymbolsgettingInsideBook[this.symbol.length - 1].on(
      "end",
      this.startShakeAnimation
    );

    //---create spin for overlay

    this.tweenspinningOverlayLine_small = PIXI.tweenManager.createTween(
      this.spinningOverlayLine_small
    );
    this.tweenspinningOverlayLine_small
      .from({ alpha: 1, rotation: 0 })
      .to({ alpha: 1, rotation: -Math.PI * 2 });
    this.tweenspinningOverlayLine_small.time = 400;
    // this.tweenBookShake.delay = 1000;
    this.tweenspinningOverlayLine_small.loop = true;
    this.tweenspinningOverlayLine_small.easing = PIXI.tween.Easing.linear();
    // this.tweenBookShake.on("end", this.shakeNewPosition);

    ///---create reveal tweeen

    this.opticalFlareTween = PIXI.tweenManager.createTween(this.opticalFlare);
    this.opticalFlareTween
      .from({ alpha: 1, scale: { x: 0, y: 0 } })
      .to({ alpha: 1, scale: { x: 3, y: 3 } });
    this.opticalFlareTween.time = 500;
    // this.tweenBookShake.delay = 1000;
    this.opticalFlareTween.loop = false;
    this.opticalFlareTween.easing = PIXI.tween.Easing.linear();

    this.opticalFlareOutTween = PIXI.tweenManager.createTween(
      this.opticalFlare
    );
    this.opticalFlareOutTween
      .from({ alpha: 1, scale: { x: 3, y: 3 } })
      .to({ alpha: 0, scale: { x: 3.5, y: 3.5 } });
    this.opticalFlareOutTween.time = 1000;
    // this.opticalFlareOutTween.delay = 1000;
    this.opticalFlareOutTween.loop = false;
    this.opticalFlareOutTween.easing = PIXI.tween.Easing.linear();
    this.opticalFlareTween.chain(this.opticalFlareOutTween);

    this.opticalExplosion.onComplete = this.stopRevealExplosion;

    ///create the BonusSymbolRevealTween
    this.tweenBonusSymbolIn = PIXI.tweenManager.createTween(
      this.bonusSymbolSelectedBG
    );
    this.tweenBonusSymbolIn
      .from({ alpha: 0, scale: { x: 0, y: 0 } })
      .to({ alpha: 1, scale: { x: 1.2, y: 1.2 } });
    this.tweenBonusSymbolIn.time = 1000;
    // this.tweenBookShake.delay = 1000;
    this.tweenBonusSymbolIn.loop = false;
    this.tweenBonusSymbolIn.easing = PIXI.tween.Easing.outSine();

    // this.tweenBonusSymbolIn.start()
  };
  private playThrowSound = (): void => {
    //-audio

    this.sound_throwSymbol.play("sound");
  };
  private startThrowAnimation = (): void => {
    //anim
    let throwDistance = 800;
    let throwAngle = 0; //
    ///-create tween book throw aways unpicked symbols so 8 symbols are thrwon away
    for (let i = 0; i < this.tweenthrowSymbolsAway.length; i++) {
      //make symbols to go to random direction
      throwAngle = i * (360 / (this.tweenthrowSymbolsAway.length + 1));
      let angleToLocationX = throwDistance * Math.cos(throwAngle);
      let angleToLocationY = throwDistance * Math.sin(throwAngle);
      this.tweenthrowSymbolsAway[i]
        .from({
          x: 0,
          y: 0,
          scale: { x: this.bookMaxScale, y: this.bookMaxScale },
          alpha: 1,
        })
        .to({
          x: angleToLocationX,
          y: angleToLocationY,
          scale: { x: 0.5, y: 0.5 },
          alpha: 0,
        });
      this.tweenthrowSymbolsAway[i].delay = i * 500;
      this.tweenthrowSymbolsAway[i].reset();
      this.tweenthrowSymbolsAway[i].start();
    }

    // console.log("----", this.tweenthrowSymbolsAway.length);
  };

  public goToResults = (): void => {
    if (this.skipBtn.getImage().alpha == 1) {
      this.skipAndGotoEndResult();
    }
  };
  private skipAndGotoEndResult = (): void => {
    this.ended = true;
    // console.log('ENDED TRUE')
    //-disable all
    this.resetAnimationsBeforeendResult();
    //end result
    this.endShakeandThrow();
  };
  private resetAnimationAfterResult = (): void => {
    this.bonusSymbolSelectedBG.gotoAndStop(0);
    this.revealExplosionStart.gotoAndStop(0);
    this.opticalExplosion.gotoAndStop(0);
    this.opticalFlareTween.stop();
    this.opticalFlareOutTween.stop();
    this.tweenBonusSymbolIn.stop();
  };
  private resetAnimationsBeforeendResult = (): void => {
    //--reset circualr Spinning animations
    this.spinningOverlayLine_small.alpha = 0; //-glowing  disc around book
    this.tweenspinningOverlayLine_small.stop(); //-tween of  glowing disc
    this.stopLightSpineffects();

    //reset symbols animation spinning around the book
    this.tweenTwoParentCircleRotateAround.stop();
    this.animationOneContainer.rotation = 0;
    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.symbolAppearingtween[i].stop();
      this.symbolAppearingtween[i].reset();
    }

    //reset symbols animation spinning around the book
    for (
      let i = 0;
      i < this.tweenTwoParentCircleRotateAroundCounterRotation.length;
      i++
    ) {
      this.tweenTwoParentCircleRotateAroundCounterRotation[i].stop();
    }

    //--reset book abosrbing symbols

    for (let i = 0; i < this.tweenSymbolsgettingInsideBook.length; i++) {
      this.tweenSymbolsgettingInsideBook[i].stop();
    }
    //--reset throwing tween
    this.stopThrowTween();

    //-resetclock

    this.tweenClock.stop();

    this.pointerHour.rotation = 0;

    //-reset the symbols
    for (let i = 0; i < this.symbol.length; i++) {
      this.symbol[i].alpha = 0;
      this.symbol[i].scale.set(0);
      this.symbol[i].position.set(0);
    }
    //-blue glow scale down reset
    this.bgBookStart.alpha = 0;
    this.bgFlareSpinTween.stop();
    this.bgFlareshrinkInTween.stop();
    this.bgFlareSpinTween.reset();
    this.bgFlareshrinkInTween.reset();

    //- book drop dirt effetc remove
    this.smallWinSparksAnimationIN.stop();
    this.shockwaveTween.stop();
    this.smallWinSparksAnimationIN.gotoAndStop(0);

    //reset shake and book motions
    this.tweenBookIn.stop();
    this.book.alpha = 0;
    this.book.scale.set(0);

    this.shakeCounters = 0;
    this.stopAndClearShake(); //book  rotation shake reset

    this.stopBookFloat(); ///-booking bobbing up and down reset

    // this.endShakeandThrow();

    //optical explosions
    this.opticalExplosion.gotoAndStop(0);

    this.bonusSymbolSelectedBG.alpha = 0;
    this.labelBonusGame.alpha = 0;
    this.resetgenerated();
    ///-hide the result
    this.stopBonusSymbolSelected();
  };

  private resetAll = (): void => {
    this.resetAnimationsBeforeendResult(); //-resset the generated symbols texture;
    this.resetAnimationAfterResult();
    this.bgBookStart.alpha = 1;
    this.displayContinueButton(false);
    this.displaySkip(true);
    this.stopAllSounds();
  };
  public close = (): void => {
    this.resetAll();
    this.parent.alpha = 0;
    this.displayContinueButton(false);
    this.displaySkip(false);
    if (this.activeGameData.blackScreen2 != undefined) {
      this.activeGameData.blackScreen2.setVisible(false);
    }

    //if possible fo spin
    if (this.isOpen) {
      this.activeGameData.mainGame
        .getBonusSymbolPickedOverlay()
        .setVisible(true);
      //update the total win
      this.activeGameData.mainGame.setBonusLeft(
        this.activeGameData.GameContext().gameRoundBalance.bonusSpins
      );
      //-
      onPlayButtonDown(this.activeGameData);
    }
    this.isOpen = false;
  };

  public forceClose = (): void => {
    this.resetAll();
    this.parent.alpha = 0;
    this.displayContinueButton(false);
    this.displaySkip(false);
    if (this.activeGameData.blackScreen2 != undefined) {
      this.activeGameData.blackScreen2.setVisible(false);
    }

    this.isOpen = false;
  };
  private startShakeAnimation = (): void => {
    //-change  the disc color to golden
    this.spinningBlueToGoldeffect.texture = PIXI.Texture.fromFrame(
      "bgFixedGold.png"
    );

    ///---all symbols in so generate a new symbols

    this.generateThrowingSymbols();

    //-clear the spin animation
    this.tweenTwoParentCircleRotateAround.stop();
    for (
      let index = 0;
      index < this.tweenTwoParentCircleRotateAroundCounterRotation.length;
      index++
    ) {
      this.tweenTwoParentCircleRotateAroundCounterRotation[index].stop();
    }
    //startspin effects

    this.tweenBookSpinInGlow.reset();
    this.tweenBookSpinInGlow.start();

    ///start shake
    this.shakeNewPosition();

    //--clock neddle animation

    this.tweenClock.time = 300;
    // this.tweenBookShake.delay = 1000;
    this.tweenClock.loop = true;
    this.tweenClock.easing = PIXI.tween.Easing.linear();
    this.tweenClock.start();
  };
  private startLightSpinEffect = (): void => {
    this.tweenBookSpinGlow.reset();
    this.tweenBookSpinGlow.start();
    this.spinningOverlayLine_small.alpha = 0;
    this.tweenspinningOverlayLine_small.reset();
    this.tweenspinningOverlayLine_small.start();

    //-resetClock this.tweenClock=   PIXI.tweenManager.createTween(this.pointerHour);
    this.stopClockAnim();
    this.tweenClock.start();
  };

  private stopClockAnim = (): void => {
    this.tweenClock.stop();
    this.pointerHour.rotation = 0;
  };
  private shakeNewPosition = (): void => {
    let maxPositionOffset = 30;
    let maxRotationOffset = 12;
    let randomRot =
      ((Math.random() * maxRotationOffset - maxRotationOffset / 2) * Math.PI) /
      180;
    let randomx = Math.random() * maxPositionOffset - maxPositionOffset / 2;
    let randomy = Math.random() * maxPositionOffset - maxPositionOffset / 2;
    this.tweenBookShake.to({
      rotation: randomRot,
      x: randomx,
      y: randomy,
      scale: { x: 0.7, y: 0.7 },
    });
    this.tweenBookShake.reset();
    this.tweenBookShake.start();

    this.shakeCounters++;
    if (this.shakeCounters == this.startThrowCounterAfterXShake) {
      this.startThrowAnimation();
    }
    if (this.shakeCounters == 120) {
      this.revealExplosionStart.gotoAndPlay(0);
    }
  };

  private endShakeandThrow = (): void => {
    //-audio

    this.sound_revealSymbol.stop();
    this.sound_revealSymbolLonger.stop();

    this.sound_revealSymbol.play("sound");
    this.sound_revealSymbolLonger.play("sound");
    //-anim

    this.displaySkip(false);
    this.displayContinueButton(true);
    if (this.revealExplosionStart.playing == false) {
      this.revealExplosionStart.gotoAndPlay(0);
    }
    this.stopAndClearShake();
    this.stopLightSpineffects();
    this.stopBookFloat();
    this.stopThrowTween();

    //-start explosion animation
    this.opticalFlareTween.reset();
    this.opticalFlareTween.start();
    this.opticalExplosion.gotoAndPlay(0);

    ///-tweenIn Frame With Symbol
    this.displayBonusSelected();
    this.book.alpha = 0;
  };

  private displayBonusSelected = (): void => {
    this.bonusSymbolSelectedBG.alpha = 1;
    this.bonusSymbolSelected.alpha = 1;
    this.tweenBonusSymbolIn.reset();
    this.tweenBonusSymbolIn.start();

    //--setTexture to result
    let index = this.resultIndex - 1; //-1 bc the  value on client start at 0 and in server  at 1

    this.bonusSymbolSelected.textures = this.allSymbolMovieClips[
      index
    ].textures;
    this.bonusSymbolSelected.gotoAndPlay(0);
    this.bonusSymbolSelectedBG.gotoAndPlay(0);
    this.labelBonusGame.alpha = 1;

    this.bgPickedSymbolTween.reset();
    this.bgPickedSymbolTween.start();
  };

  private stopBonusSymbolSelected = (): void => {
    this.tweenBonusSymbolIn.stop();
    this.bonusSymbolSelected.stop();
    this.bonusSymbolSelectedBG.stop();
    this.bonusSymbolSelectedBG.alpha = 0;
    this.bonusSymbolSelected.alpha = 0;
    this.revealExplosionStart.gotoAndStop(0);

    this.opticalFlareTween.stop();
    this.opticalFlareTween.reset();
    this.opticalFlareOutTween.stop();
    this.opticalFlareOutTween.reset();
    this.opticalFlare.alpha = 0;

    this.bgPickedSymbol.alpha = 0;
    this.bgPickedSymbolTween.stop();
    this.bgPickedSymbolTween.reset();
  };
  // private stopHit=():void=>
  // {
  //   this.book.scale.set(this.bookMaxScale);
  //   this.tweenBookHit.stop();
  // }
  private stopLightSpineffects = (): void => {
    this.spinningOverlayGlow.alpha = 0;
    this.spinningOverlayGlow.rotation = 0;
    this.spinningOverlayGlow.scale.set(0, 0);

    this.spinningOverlayLine_small.alpha = 0;
    this.spinningOverlayLine_small.rotation = 0;

    this.tweenBookSpinGlow.stop();
    this.tweenBookPulseGlow.stop();
    this.tweenspinningOverlayLine_small.stop();
    this.tweenBookSpinInGlow.stop();

    //-
  };
  private stopThrowTween = (): void => {
    for (let i = 0; i < this.tweenthrowSymbolsAway.length; i++) {
      this.tweenthrowSymbolsAway[i].stop();
    }
    for (let i = 0; i < this.symbol.length; i++) {
      this.symbol[i].alpha = 0;
      this.symbol[i].position.set(0, 0);
      this.symbol[i].scale.set(0);
    }
  };

  private stopRevealExplosion = (): void => {
    // this.opticalFlareTween.stop();
    // this.opticalFlare.alpha=0;
    // this.opticalFlare.scale.set(0,0);
    this.opticalExplosion.gotoAndStop(0);
    this.tweenBonusSymbolIn.stop();
  };

  private stopAndClearShake = (): void => {
    this.tweenBookShake.stop();
    this.book.rotation = 0;
    this.book.position.set(0, 0);
  };

  private stopBookFloat = (): void => {
    this.tweenBookFloating.stop();
    this.book.position.set(0, 0);
  };

  private spinGlowAroundBook = (): void => {
    this.tweenBookPulseGlow.reset();
    this.tweenBookPulseGlow.start();
  };
  private bookHitAnimation = (): void => {
    //-audio
    this.sound_hitBook.stop();
    this.sound_hitBook.play("sound");

    //anim
    this.book.scale.set(this.bookMaxScale);
    // this.tweenBookHit.stop();
    this.tweenBookHit.reset();
    this.tweenBookHit.start();
  };

  public getIsEnded = (): boolean => {
    return this.ended;
  };
  private startAnimationOne = (): void => {
    this.ended = false;
    // console.log('ENDED FALSE')
    //-audio

    this.sound_spinning.stop();
    this.sound_spinning.play("sound");
    //--animations
    this.bgFlareSpinTween.start();
    this.book.scale.set(0);
    this.tweenBookIn.reset();
    this.tweenBookIn.start();

    this.spinningBlueToGoldeffect.alpha = 0;
    this.shockwaveTween.reset();
    this.shockwaveTween.start();

    // animatetitel
    this.labelBonusGameTween.reset();
    this.labelBonusGameTween.start();
  };
  private startAnimationTwo = (): void => {
    //book start  freeFloat
    this.book.y = 0;
    this.tweenBookFloating.reset();
    this.tweenBookFloating.start();

    //-start appearing the symbols around the book
    for (let i = 0; i < this.symbolAppearingtween.length; i++) {
      this.symbolAppearingtween[i].start();
      // this.symbolInEffects[i].gotoAndPlay(0);
    }
    this.startAnimationTween2();
  };
  private generateThrowingSymbols = (): void => {
    //
    this.symbol[this.symbol.length - 1].texture = this.allBonusSymbols[
      this.resultIndex - 1
    ]; //put the selected symbol at the end of the generated array
    //

    let tempCopyTexture: Array<PIXI.Texture> = [];

    for (let i = 0; i < this.allBonusSymbols.length; i++) {
      tempCopyTexture[i] = this.allBonusSymbols[i];
    }

    tempCopyTexture.splice(this.resultIndex - 1, 1);
    shuffleArray(tempCopyTexture);
    for (let i = 0; i < this.tweenthrowSymbolsAway.length; i++) {
      this.symbol[i].texture = tempCopyTexture[i]; //put the selected symbol at the end of the generated array
    }
  };
  private createButtons = (): void => {
    let labeltextStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowColor: "#ffffff",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#000000"],
      fontWeight: "bold",
      fontSize: 35,
      align: "left",
      wordWrap: true,
      wordWrapWidth: 800,
    });

    this.buttonExitlabel = new PIXI.Text(
      " " + this.activeGameData.gameTextGeneral.continue + " ",
      labeltextStyle
    );
    this.buttonExitlabel.anchor.set(0.5);
    //create button
    this.buttonExit.placeButton(this.parent, [
      0,
      this.activeGameData.size[1] / 2 - 150,
    ]);
    this.buttonExit.getImage().addChild(this.buttonExitlabel);

    this.buttonExit.setFunction(this.close);

    //test btn
    // this.buttonExitTest.placeButton(this.parent, [
    //   -400,
    //   this.activeGameData.size[1] / 2 - 150,
    // ]);
    this.buttonExitTest.setFunction(this.testReplay);

    //--skip btn
    this.skipBtn.placeButton(this.parent, [
      0,
      this.activeGameData.size[1] / 2 - 150,
    ]);

    this.skipBtn.setFunction(this.skipAndGotoEndResult);
  };

  private displaySkip = (bool: boolean): void => {
    if (this.activeGameData.replayMode) {
      bool = false;
    }
    this.skipBtn.setInteractive(bool);
    this.skipBtn.setAlpha(bool ? 1 : 0);
  };
  private displayContinueButton = (bool: boolean): void => {
    if (this.activeGameData.replayMode) {
      bool = false;
    }
    this.buttonExit.setInteractive(bool);
    this.buttonExit.setAlpha(bool ? 1 : 0);
  };
  private testReplay = (): void => {
    // let index = Math.floor(Math.random() * 9) + 1;
    this.startNewBonusAnimation(this.resultIndex);
    // console.log("restart");
  };
  private resetgenerated = (): void => {
    for (let i = 0; i < this.allBaseSymbols.length; i++) {
      this.symbol[i].texture = this.allBaseSymbols[i];
    }
    //-reset  the disc color
    this.spinningBlueToGoldeffect.texture = PIXI.Texture.fromFrame(
      "bgFixed.png"
    );
  };

  public startNewBonusAnimation = (resultIndex: number): void => {
    this.isOpen = true;
    this.parent.alpha = 1;
    if (this.activeGameData.blackScreen2 != undefined) {
      this.activeGameData.blackScreen2.setVisible(true);
      this.activeGameData.blackScreen2.setAlpha(0.8);
      // console.log("ssssssssssss")
    }

    this.resetAll();
    this.resultIndex = resultIndex;
    this.startAnimationOne();

    //update the total win
    this.activeGameData.mainGame.setBonusLeft(
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins
    );
  };

  public isVisible = (): boolean => {
    return this.parent.alpha == 1;
  };

  public setPortraitMode = (isDesktop: boolean): void => {
    if (isDesktop) {
      this.parent.scale.set(1.1);
      this.parent.position.set(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[1] / 2
      );
    } else {
      this.parent.scale.set(2.5);
      this.parent.position.set(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[1] / 2 + 200
      );
    }
  };
}
